var chunkToChildrenMap = {
	"1067": [
		5450,
		6773,
		7488
	],
	"1911": [
		5450,
		6773,
		7488
	],
	"3839": [
		5398,
		9315,
		9975,
		8454,
		7602,
		2062,
		7763,
		1136,
		661,
		9558,
		615,
		2779,
		4843,
		623,
		6535,
		5540,
		1620,
		9793,
		1313,
		4140
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));